import {useState, memo} from 'react'
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import styled from 'styled-components';

import Title from '../Components/Title'

import { 
    WhiteSpace,
    TextL,
    Button,
    TextLinear,
    TextXL,
    TextMax,
    TextM,
    TextS,
    Hr,
} from '../../components';

import {
    Card
} from '../../components'

import {
    useSilver
} from '../../context/silver'

import useCopy from '../../hook/useCopy'

import {
    EtherToInt
} from '../../ethers/e'

import {
    useBuySilver
} from '../../hook/silver/uesSilver'

import {
    useEthers
} from '../../ethers/index'

import { useTranslation } from 'react-i18next';

import useLanguage from '../../hook/useLanguage'

import {
    CheckProtocal
} from '../Protocol'


function SilverVIP({disabled = false}) {
    const button = useBuySilver()
    return <Button style={{height: 'min-content'}} disabled={disabled} size='small' {...button}/>
}

function ShareLink() {
    const {account} = useEthers()
    const copy = useCopy()
    const invitLink = () => {
        copy(window.location.href+'?r=' + account)
    }
    const {t} = useTranslation()
    return <TextS onClick={invitLink} style={{display:'block'}} color='2'>{t('Copy Share Link')} {'>'}</TextS>
}

function Index() {
    const {
        usdgBalance,
        usdtBalance,
        silverVIP,
        cvBalance,
        totalU,
        gold,
        totalLocked,
        teamShare
    } = useSilver()
    // console.log(
    //     gold
    // )
    const {t} = useTranslation()
    return (
        <Container>
            <WhiteSpace size={.4}/>
            <Title src='/icon/wallet.png' shadow='unset'>
                <TextXL style={{lineHeight: '22px'}} >{t('My Wallet')}</TextXL>
            </Title>
            <Card style={{overflow:'unset'}} spacing={[0.8, 1]}>
                <WhiteSpace size={1.2}/>
                <TextMax>$ {EtherToInt(totalU)}</TextMax>
                <WhiteSpace size={1}/>
                <Hr />
                <WhiteSpace size={1}/>
                <Stack
                    direction="row"
                    justifyContent="space-between"
                >
                    <div>
                        <TextM>USDT</TextM>
                        <TextS style={{display:'block'}} color='2'>Tether (USDT)</TextS>
                    </div>
                    <div style={{textAlign:'right'}}>
                        <TextM>{EtherToInt(usdtBalance)}</TextM>
                        <TextS style={{display:'block'}} color='2'>$ {EtherToInt(usdtBalance)}</TextS>
                    </div>
                </Stack>
                <WhiteSpace size={.4}/>
                <Stack
                    direction="row"
                    justifyContent="space-between"
                >
                    <div>
                        <TextM>USDG</TextM>
                        <TextS style={{display:'block'}} color='2'>USD Gold</TextS>
                    </div>
                    <div style={{textAlign:'right'}}>
                        <TextM>{EtherToInt(usdgBalance)}</TextM>
                        <TextS style={{display:'block'}} color='2'>$ {EtherToInt(usdgBalance)}</TextS>
                    </div>
                </Stack>
                <WhiteSpace size={.4}/>
                <Stack
                    direction="row"
                    justifyContent="space-between"
                >
                    <div>
                        <TextM>CV</TextM>
                        <TextS style={{display:'block'}} color='2'>{t('Contribution value')}</TextS>
                    </div>
                    <div style={{textAlign:'right'}}>
                        <TextM>{EtherToInt(cvBalance)}</TextM>
                        <TextS style={{display:'block'}} color='2'>--</TextS>
                    </div>
                </Stack>
            </Card>
            <WhiteSpace />
            <Card style={{overflow:'unset'}} spacing={[0.8, 1]}>
                <Stack
                    direction="row"
                    justifyContent="space-between"
                >
                    <Stack
                        direction="row"
                        justifyContent="start"
                        alignItems='center'
                    >
                        <PoolLogo
                            style={{
                                width: '35px',
                                height: '35px',
                                marginRight: '6px'
                            }}
                            src='/icon/ag.png'
                        /> 
                        <div>
                            <TextL style={{display:'block', lineHeight: 1}}>{t('Silver')} {t('Asset Portfolio')}</TextL>
                            <TextS color='2'>10000 USDT {t('for Upgrade')} VIP</TextS>
                        </div>
                    </Stack>
                    <CheckProtocal>
                        {
                            silverVIP ?
                            <PoolLogo
                                src='/icon/vip.png'
                                style={{
                                    border: '1px solid #f8d83a',
                                    borderRadius: '4px'
                                }}
                            />:
                            <SilverVIP disabled={usdtBalance*1 < 10000}/>
                        }
                    </CheckProtocal>
                </Stack>
                <WhiteSpace size={1}/>
                <Stack
                    direction="row"
                    justifyContent="space-between"
                >
                    <div>
                        <TextM>{t('Unlockable')}</TextM>
                        <TextS style={{display:'block'}} color='2'>{t('Total Unlocked')} USDG</TextS>
                    </div>
                    <div style={{textAlign:'right'}}>
                        <TextM>{EtherToInt(totalLocked)}</TextM>
                        <TextS style={{display:'block'}} color='2'>USDG</TextS>
                    </div>
                </Stack>
                <WhiteSpace size={.4}/>
                <Stack
                    direction="row"
                    justifyContent="space-between"
                >
                    <div>
                        <TextM>{t('Team Reward')}</TextM>
                        <ShareLink />
                    </div>
                    <div style={{textAlign:'right'}}>
                        <TextM>{EtherToInt(teamShare)}</TextM>
                        <TextS style={{display:'block'}} color='2'>0x..121</TextS>
                    </div>
                </Stack>
            </Card>
            <WhiteSpace />
            <Card style={{overflow:'unset'}} spacing={[0.8, 1]}>
                <Stack
                    direction="row"
                    justifyContent="start"
                    alignItems='center'
                >
                    <PoolLogo
                        style={{
                            width: '35px',
                            height: '35px',
                            marginRight: '6px'
                        }}
                        src='/icon/au.png'
                    /> 
                    <div>
                        <TextL style={{display:'block', lineHeight: 1}}>Gold {t('Asset Portfolio')}</TextL>
                        <TextS color='2'>200,000 USDT {t('for Upgrade')} VIP</TextS>
                    </div>
                </Stack>
                <WhiteSpace size={1}/>
                <Stack
                    direction="row"
                    justifyContent="space-between"
                >
                    <div>
                        <TextM>{t('Locked')}</TextM>
                        <TextS style={{display:'block'}} color='2'>{t('Total Unlocked')} USDG</TextS>
                    </div>
                    <div style={{textAlign:'right'}}>
                        <TextM>{EtherToInt(gold.totalLocked)}</TextM>
                        <TextS style={{display:'block'}} color='2'>USDG</TextS>
                    </div>
                </Stack>
                {/* <WhiteSpace size={.4}/>
                <Stack
                    direction="row"
                    justifyContent="space-between"
                >
                    <div>
                        <TextM>Team Reward</TextM>
                        <TextS style={{display:'block'}} color='2'>Copy Share Link {'>'}</TextS>
                    </div>
                    <div style={{textAlign:'right'}}>
                        <TextM>132,321.01</TextM>
                        <TextS style={{display:'block'}} color='2'>0xa..121</TextS>
                    </div>
                </Stack> */}
            </Card>
            <WhiteSpace />
            <Card style={{overflow:'unset'}} spacing={[0.8, 1]}>
                <Stack
                    direction="row"
                    justifyContent="space-between"
                >
                    <TextM>Language</TextM>
                    <ChangeLanguage />
                </Stack>
            </Card>
        </Container>
    )
}

export default Index


const PoolLogo = styled('img')`
    width: 25px;
    height: 25px;
    display: inline-block;
    vertical-align: sub;
    margin-right: 4px;
`

const ChangeLanguage = memo(() => {
    const {
        lang,
        resources,
        checkoutLanguage
    } = useLanguage()

  return (
    <div>
        {
            resources.map(v => (
                <TextM
                    key={v}
                    style={{
                        padding:'2px 4px',
                        marginLeft:'6px'
                    }}
                    color={v === lang ? 1 : 2}
                    onClick={() => {
                        checkoutLanguage(v)
                    }}
                >{v}</TextM>
            ))
        }
    </div>
  )
})